import ServiceBusController from "servicestack/service-bus.controller";
import layouts from "servicestack/tags/pagination/tag-pagination.layouts";

export default class TagPaginationController extends ServiceBusController {
  $onChanges(...changes) {
    const g = this;
    console.debug("pagination$onChanges", {
      g,
      changes
    });
    g.filter.init();
  }

  getFilter() {
    return this.query.filters.filter(f => f.tagKind === this.tagKind)[0];
  }

  show(index) {
    const $ctrl = this;
    return (
      $ctrl.filter.isSelected($ctrl.filter.items[index - 1]) ||
      $ctrl.filter.isSelected($ctrl.filter.items[index + 1])
    );
  }

  prefix(index) {
    const $ctrl = this;
    return $ctrl.filter.isSelected($ctrl.filter.items[index + 1])
      ? "Previous"
      : "Next";
  }

  back() {
    this.currentLevel.back();
  }

  select(tag) {
    this.currentLevel.select(tag);
  }

  templateUrl() {
    return layouts[this.layout] || Object.values(layouts)[0];
  }

  scrubClassName(className) {
    return className
      .split(/\W+/gi)
      .join("-")
      .toLowerCase();
  }
}
